import { createContext, useContext, useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import * as Icons from "lucide-react";
import { DocumentPanel } from "./DocumentPanel";

const Ctx = createContext(() => {});
export const useRecordEditor = () => useContext(Ctx);

// One global full-field editor drawer; any section can open any Firestore doc in it.
export function RecordEditorProvider({ children }) {
  const [rec, setRec] = useState(null);
  return (
    <Ctx.Provider value={(path, id) => setRec({ path, id })}>
      {children}
      <Sheet open={!!rec} onOpenChange={(o) => !o && setRec(null)}>
        <SheetContent className="w-full sm:max-w-2xl overflow-y-auto z-[100]" data-testid="record-editor-drawer">
          {rec && (
            <>
              <SheetHeader className="text-left mb-4">
                <SheetTitle className="font-heading break-all">Edit record</SheetTitle>
                <SheetDescription className="font-mono break-all" data-testid="record-editor-path">{rec.path}/{rec.id}</SheetDescription>
              </SheetHeader>
              <DocumentPanel path={rec.path} id={rec.id} onDeleted={() => setRec(null)} />
            </>
          )}
        </SheetContent>
      </Sheet>
    </Ctx.Provider>
  );
}

export function EditRecordButton({ path, id, className = "" }) {
  const open = useRecordEditor();
  if (!path || !id) return null;
  return (
    <Button size="icon" variant="ghost" className={`h-7 w-7 ${className}`} title={`Edit ${path}/${id}`}
      onClick={(e) => { e.stopPropagation(); open(path, id); }} data-testid={`edit-record-${path.replace(/\//g, "_")}-${id}`}>
      <Icons.Pencil className="h-3.5 w-3.5" />
    </Button>
  );
}
